import Icon from "apps/website/components/base/Icon/Icon";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import {
  boldenBacktickText,
} from "apps/website/utils/website/boldenBacktickText";
import cx from "apps/website/utils/misc/cx";

import { IFunctionalCard } from "../MessagingCard.map";

export const FunctionalCard = ({ title, description, icon }: IFunctionalCard) => (
  <div className="flex items-start gap-2" data-component={FunctionalCard.name}>
    { icon && (<Icon className={cx("shrink-0", icon.className)} size="xsmall" scale color={icon.color ?? "error"} {...icon} />) }

    <div className="flex flex-col gap-2">
      { title && <TextSubtitle size={2}>{ title }</TextSubtitle> }
      { typeof description === "string" ? (
        <TextBody size={2}>{ boldenBacktickText(description) }</TextBody>
      ) : (
        description
      ) }
    </div>
  </div>
);
